<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useServiceStore } from '@stores/service'
import { format } from '@formkit/tempo'
import ContactScroll from '@components/contact/ContactScroll.vue'

const serviceStore = useServiceStore()
const currentTime = ref(new Date())
const timeFormat = ref('24')

let timeInterval = null

const currentTimeFormatted = computed(() => {
	const now = currentTime.value
	return timeFormat.value == '24' ? format(now, { time: 'short' }) : format(now, 'h:mm A')
})

const steps = ref([
	{
		name: 'Contact Us',
		slug: 'contact-us',
		hallmark: 'CU',
		timeline: 'eta 24 hours',
		active: true,
	},
	{
		name: 'Schedule Meeting',
		slug: 'schedule-meeting',
		hallmark: 'SM',
		timeline: 'eta 48 hours',
	},
	{
		name: 'Scope & Kick Off',
		slug: 'scope-kick-off',
		hallmark: 'KO',
		timeline: '...',
	},
	{
		name: 'Project Complete',
		slug: 'project-complete',
		hallmark: 'GG',
		timeline: '...',
	},
	{
		name: 'Return Journey',
		slug: 'return-journey',
		hallmark: 'N',
		timeline: null,
	},
])

onMounted(() => {
	timeInterval = setInterval(() => {
		currentTime.value = new Date()
	}, 1000)
})

onUnmounted(() => {
	if (timeInterval) {
		clearInterval(timeInterval)
	}
})
</script>

<template>
	<section class="relative bg-crowns-off-black bg-[url('https://cdn.papercrowns.com/website/images/backgrounds/contact-alt.jpg')] bg-bottom bg-no-repeat pb-24">
		<div class="container">
			<div class="mb-10 flex flex-col gap-5 text-center">
				<h4>The Castle Awaits</h4>
				<!-- <span class="text-lg font-semibold">Hop on for the ride</span> -->
			</div>
			<div class="flex grid-cols-4 flex-col gap-5 md:grid">
				<div class="col-span-3 xl:col-span-2 xl:col-start-2">
					<ContactScroll :email-direct="true" />
				</div>
				<div class="hidden flex-col gap-5 pt-5 md:flex">
					<div class="h-40 w-40 bg-crowns-dark-grey pt-6">
						<div class="relative flex h-full flex-col justify-between border-t border-crowns-off-white px-3 pt-3 text-lg font-semibold leading-tight" @click="timeFormat = timeFormat == '24' ? '12' : '24'">
							Next
							<br />
							Departure
							<img class="h-[4.25rem] object-contain" src="https://cdn.papercrowns.com/website/images/elements/etches/stopwatch-half.png" alt="Stopwatch" />
							<transition mode="out-in" name="fade-fast">
								<div class="absolute right-3 top-2 select-none text-base font-normal text-crowns-castle-stone" :key="timeFormat">{{ currentTimeFormatted }}</div>
							</transition>
						</div>
					</div>
					<div class="relative flex flex-col gap-5">
						<div class="absolute h-full w-8 rounded-full bg-gradient-to-b from-crowns-grey to-crowns-castle-shadow/50"></div>
						<div class="relative flex gap-3" v-for="step in steps">
							<div :class="['flex w-8 flex-col justify-between rounded-full', { 'bg-crowns-castle-shadow': step.active }]">
								<div class="crowns flex h-8 w-8 items-center justify-center rounded-full bg-white text-sm font-semibold text-crowns-off-black">{{ step.hallmark }}</div>
								<div class="flex h-8 items-center justify-center" v-if="step.timeline"><i :class="['fas fa-chevron-down', { '-mb-1 animate-bounce': step.active }]" /></div>
							</div>
							<div class="flex flex-col gap-9">
								<div class="py-.5 border border-crowns-castle-stone bg-crowns-grey px-1 text-sm">{{ step.name }}</div>
								<p class="text-xs text-crowns-off-white" v-if="step.timeline">{{ step.timeline }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
